import { Component, OnInit, Input, OnChanges, OnDestroy } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { EMPTY, Subscription } from 'rxjs';
import { CentersCentersService } from 'src/app/services/centers-services/centers-centers-service/centers-centers.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/internal/operators/catchError';
import { Center } from 'src/app/models/center-model/center.model';

@Component({
  selector: 'app-centers-center-alert-info-card',
  templateUrl: './centers-center-alert-info-card.component.html',
  styleUrls: ['./centers-center-alert-info-card.component.scss']
})
export class CentersCenterAlertInfoCardComponent implements OnInit, OnChanges, OnDestroy {

  @Input() center: Center;
  basicDataForm = new FormGroup({
    infoAlert: new FormControl(null)
  });
  updateInfoAlertSubscription: Subscription;

  constructor(private centersCentersService: CentersCentersService,
              private snackbarService: SnackBarService) { }

  ngOnInit() { }

  ngOnChanges() {
    if (this.center && this.center.InfoAlert) {
      this.resetForm();
    }
  }

  public inputChange() {
    if (this.basicDataForm.get('infoAlert').dirty) {
      this.submitForm();
    }
  }

  private submitForm() {
    this.updateInfoAlertSubscription = this.centersCentersService.updateInfoAlert(this.center.InternalId, this.basicDataForm.get('infoAlert').value).pipe(
      tap(o => this.snackbarService.open(o['message'], 'success')),
      catchError(error => { this.snackbarService.open(error['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  private resetForm() {
    this.basicDataForm.patchValue({
      infoAlert: this.center.InfoAlert
    });
  }

  ngOnDestroy() {
    if (this.updateInfoAlertSubscription) { this.updateInfoAlertSubscription.unsubscribe(); }
  }

}
